module.exports = __webpack_public_path__ + "img/px-thumbnail.099188de.png";